import {Component, OnInit, Input, OnChanges, SimpleChanges} from '@angular/core';
import {GlobalService} from '../global.service';

@Component({
  selector: 'app-loading-indicator',
  templateUrl: './loading-indicator.component.html',
  styleUrls: ['./loading-indicator.component.css']
})
export class LoadingIndicatorComponent implements OnInit {


  constructor(private globalService: GlobalService) {
  }

  ngOnInit() {
  }


}
